import Image from "next/image";
import {Link, Locale} from "@/i18n/routing";
import React from "react";
import type { Company } from "@/types/contentful/company.d";

export type LogoType = "footerLogo" | "headerLogo"; // Add more logo types as needed

interface LogoProps {
  company?: Company;
  logoType: LogoType; // Specify which logo to use (e.g., "footerLogo", "headerLogo")
  fallbackurl: string; // Fallback URL for the logo
  height:number;
  width:number;
  locale:Locale;
}

export default function ColletteLogo({company, logoType, fallbackurl, height,width, locale}: LogoProps) {
  const url = company?.logo?.fields?.[logoType]?.fields?.file?.url;
  const fallbackUrl = fallbackurl;

  return (
    <Link href="/" locale={locale}>
      <Image
        src={url ? `https:${url}` : fallbackUrl}
        width={width}
        height={height}
        alt={company?.logo?.fields?.title || "Collette"}
        className="mt-3"
        priority
      />
    </Link>
  );
}